const validateDownloadFormat = (params) => {
  if (params?.format && !["excel", "pdf"].includes(params.format)) {
    throw new Error("Invalid format. strictly allowed 'excel' or 'pdf'");
  }
};

// Split out of apis/MyFPO/memberApi.js — per mybusiness.md §3-4, Share Capital is proxied
// (shared), unlike Member CRUD which stays MyFPO-only / gets a fresh MyBusiness implementation.
export const createShareCapitalApi = (api) => ({
  getShareCapital: (fpoId, memberId) => api.get(`/fpo/${fpoId}/member/${memberId}/shares`),
  // Every member's share capital record in one call (used for the Share Transfer folio dropdown).
  getAllMembersShareCapital: (fpoId) => api.get(`/fpo/${fpoId}/members/shares`),
  createShareCapital: (fpoId, memberId, data) => api.post(`/fpo/${fpoId}/member/${memberId}/shares`, data),
  updateShareCapital: (fpoId, memberId, id, data) => api.patch(`/fpo/${fpoId}/member/${memberId}/shares/${id}`, data),
  getShareCapitalById: (fpoId, memberId, id) => api.get(`/fpo/${fpoId}/member/${memberId}/shares/${id}`),
  deleteShareCapitalById: (fpoId, memberId, id) => api.delete(`/fpo/${fpoId}/member/${memberId}/shares/${id}`),
  downloadShareCapital: (fpoId, params) => {
    validateDownloadFormat(params);
    return api.get(`/fpo/${fpoId}/shares/download`, { params, responseType: "blob" });
  },
});
